export default __webpack_public_path__ + "static/media/savetovalista_u_beogradu.4220e147.jpg";